// Реестр экранов → page_name для аналитики (page_view).
// Источник: backend agent_docs/analytics-ga4/page-names.md — имена утверждены отделом продаж 11.08.2026,
// менять нельзя (на них завязаны теги GTM и отчёт «Переходы по экранам»).
// Путь не из словаря → null → переход не трекается: так автоматически исключены все экраны «Управления» и /test.
export const PAGE_NAMES = {
  "/": "home",
  "/order": "order_forming",
  "/templates": "order_templates",
  "/archivepharmacy": "orders_archive_pharmacy",
  "/archivefilial": "orders_archive_filial",
  "/deletedordersarchivepharmacy": "orders_archive_deleted",
  "/discount": "discounts",
  "/scheduler": "scheduler",
  "/chat": "chat",
  "/partnercabinet": "partner_cabinet",
  "/usersettings": "user_settings",
  "/goods": "goods_catalog",
  "/annotation": "annotations",
  "/distributor": "distributors",
  "/price": "prices",
  "/user": "users",
  "/city": "cities",
  "/priceanalysisreport": "report_price_analysis",
  "/averagepricesharesalesreport": "report_avg_price_share_sales",
  "/filialpriceactualityreport": "report_price_actuality",
  "/login": "login",
  "/resetpassword": "reset_password",
};

// Сравнение без учёта регистра и без завершающего «/» (роуты вида /UserSettings)
export function resolvePageName(path) {
  if (!path) return null;
  let normalized = String(path).split("?")[0].split("#")[0].toLowerCase();
  if (normalized.length > 1 && normalized.endsWith("/")) normalized = normalized.slice(0, -1);
  return PAGE_NAMES[normalized] || null;
}
